/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsHoopPlatform
 */
export interface ControlcenterMelcoModelsHoopPlatform {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoopPlatform
     */
    id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsHoopPlatform
     */
    sf_area?: number;
}

export function ControlcenterMelcoModelsHoopPlatformFromJSON(json: any): ControlcenterMelcoModelsHoopPlatform {
    return ControlcenterMelcoModelsHoopPlatformFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsHoopPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsHoopPlatform {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'sf_area': !exists(json, 'sf_area') ? undefined : json['sf_area'],
    };
}

export function ControlcenterMelcoModelsHoopPlatformToJSON(value?: ControlcenterMelcoModelsHoopPlatform | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'sf_area': value.sf_area,
    };
}


